export const modulesConfig = {
  dashboard: true,

  clientes: {
    menuCompleto: true,
    maestroPacientes: true,
    doctores: true,
    empresas: true,
    sectores: true,
    transacciones: true,
    tiposOperacion: true,
  },

  proveedores: {
    menuCompleto: true,
    maestroProveedor: true,
    transacciones: true,
    tiposOperacion: true,
  },

  productos: {
    menuCompleto: true,
    maestroProducto: true,
    transacciones: true,
    tiposOperacion: true,
    almacenes: true,
    presentacion: true,
    marcas: true,
    categorias: true,
    impuestos: true,
  },

  facturar: true,
  cotizar: true,
  compras: true,
  reportes: true,

  configuracion: {
    menuCompleto: true,
    general: true,
    roles: true,
  },

  ai: {
    menuCompleto: true,
    general: true,
    roles: true,
  },
};